import { Skeleton, Stack } from "@mui/material";

const SECTION_KEYS = ["s1", "s2"];
const ROW_KEYS = ["r1", "r2"];

export const GoalDetailSkeleton = () => (
	<Stack>
		<Stack bgcolor="background.paper" px={1.6} pt={2} pb={1.6} gap={1.2}>
			<Stack direction="row" alignItems="center" gap={1.2}>
				<Skeleton
					variant="rounded"
					width={48}
					height={48}
					sx={(theme) => ({ borderRadius: theme.radii.lg })}
				/>
				<Stack flex={1} gap={0.6}>
					<Skeleton variant="rounded" width="50%" height={20} />
					<Skeleton variant="rounded" width="35%" height={14} />
				</Stack>
			</Stack>
			<Skeleton
				variant="rounded"
				width="100%"
				height={6}
				sx={(theme) => ({ borderRadius: theme.shape.pillRadius })}
			/>
			<Skeleton variant="rounded" width="60%" height={16} />
		</Stack>

		{SECTION_KEYS.map((sectionKey) => (
			<Stack
				key={sectionKey}
				bgcolor="background.paper"
				mt={1}
				px={1.6}
				py={1.6}
				gap={1.2}
			>
				<Skeleton variant="rounded" width="40%" height={16} />
				{ROW_KEYS.map((rowKey) => (
					<Skeleton
						key={`${sectionKey}-${rowKey}`}
						variant="rounded"
						width="100%"
						height={48}
						sx={(theme) => ({ borderRadius: theme.radii.lg })}
					/>
				))}
			</Stack>
		))}
	</Stack>
);
